module.exports = "<dt-layout class=dt-layout layout=column flex=100></dt-layout>";


//////////////////
// WEBPACK FOOTER
// ./app/app.html
// module id = 3nmL
// module chunks = 1